// extracted by mini-css-extract-plugin
export default {"relativeProfile":"RelativeTab_relativeProfile__Ss98I"};